export default "<div id=\"maps\"></div>";